import { useTranslation } from 'react-i18next';

import { SingleLineText, Title, LogoutButton } from '@bloomays-lib/ui.shared';
import RawMarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import { styled } from '@mui/material/styles';
import { useAuthStore } from '../../stores';
import { Logger } from '../../services/serviceLogger';

const logger = Logger('InvitationEmailAdded');

type InvitationEmailAddedProps = {
  email: string;
};

/**
 * Écran affiché quand une invitation vient d'ajouter l'email authentifié en secondaryEmail du
 * bloomer (checkInvitationToken → emailCaptured). Les rôles/liens Auth0 étant calculés au login,
 * on force une reconnexion : le bouton déconnecte (retour à la home). Après re-login, ProtectedRoute
 * redirige de lui-même vers l'invitation encore en cours pour finaliser l'onboarding.
 */
const InvitationEmailAdded = ({ email }: InvitationEmailAddedProps) => {
  const { t } = useTranslation(['firstCo']);
  const auth = useAuthStore((state) => state.auth);
  logger.info(`${email} added as secondary email, forcing reconnection`, { email });
  return (
    <ContainerDiv>
      <Title textTitle={t('emailAddedTitle', { ns: 'firstCo' })} />
      <MarkEmailReadIcon />
      <SingleLineText text={t('emailAdded', { ns: 'firstCo', email })} />
      <SingleLineText text={t('emailAddedReconnect', { ns: 'firstCo' })} />
      <LogoutButton logout={() => auth?.logout()} textButton="Me reconnecter" type="button" />
    </ContainerDiv>
  );
};

export default InvitationEmailAdded;
export { InvitationEmailAdded };

const ContainerDiv = styled('div')(({ theme }) => ({
  display: 'flex',
  flexFlow: 'column nowrap',
  backgroundColor: theme.palette.neutral.white,
  boxShadow: `2px 2px 20px ${theme.palette.neutral[10]}`,
  borderRadius: '10px',
  width: '40%',
  margin: '1em auto',
  padding: '1em',
  [theme.breakpoints.down('md')]: {
    width: '85%',
  },
}));

const MarkEmailReadIcon = styled(RawMarkEmailReadIcon)(({ theme }) => ({
  color: theme.palette.blue[60],
  fontSize: '130px !important',
  margin: 'auto',
}));
